import React, { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";
import ChatImage from "./ChatImage";
import classNames from "classnames";
import { get } from "lodash";

type ChatHeaderArgs = {
  title: string;
  chatId?: string;
  subtitle?: string;
  ButtonLeft?: ReactElement;
  ButtonRight?: ReactElement;
};

export default function ChatHeader({
  chatId,
  title,
  subtitle,
  ButtonLeft,
  ButtonRight,
}: ChatHeaderArgs) {
  const chatStatus = useSelector(
    (state) => chatId && get(state, ["chat", "chats", chatId, "status"]),
  );

  useEffect(() => {
    if (window.isApp) {
      // hide navigation in chat
      const navigation = document.getElementById("main-navigation");

      if (navigation) {
        navigation.classList.remove("tixxt__navigation"); // remove styles otherwise hidden is overwritten
        navigation.hidden = true;
      }
    }
  }, []);

  return (
    <div
      className={classNames(
        "chat__header px-3 grid grid-cols-[auto_1fr_auto] items-center gap-3 h-topbar",
      )}
    >
      <div className="flex items-center gap-2">
        {ButtonLeft && ButtonLeft}
        {chatId && <ChatImage chatId={chatId} name={title} />}
      </div>
      <div
        className="chat__title flex flex-col flex-1 overflow-hidden"
        title={title}
      >
        <span className="font-semibold truncate text-ellipsis text-xl">
          {title}
        </span>

        {subtitle ? (
          <>
            <span className="subtitle leading-none">{subtitle}</span>
          </>
        ) : chatStatus?.text ? (
          <span
            className="subtitle leading-none truncate"
            title={chatStatus?.text}
          >
            {chatStatus?.text}
          </span>
        ) : null}
      </div>

      {ButtonRight && ButtonRight}
    </div>
  );
}
